/** Public homepage section anchors and demo route — keep links consistent. */

export const PUBLIC_DEMO_ROUTE = '/how-it-works';

export const HOME_SECTION_IDS = {
  features: 'features',
  highlights: 'highlights',
  howItWorksTeaser: 'see-how-it-works',
  gettingStarted: 'getting-started',
  pricing: 'pricing-preview',
  partners: 'partners',
  cta: 'cta',
};

export function homeSectionHref(sectionId) {
  return `/#${sectionId}`;
}

export function scrollToHomeSection(sectionId) {
  if (typeof document === 'undefined') return;
  const el = document.getElementById(sectionId);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }
  window.location.assign(homeSectionHref(sectionId));
}
